export const BULK_UPDATE_WITH_FUNCTION_ERROR = 'BULK_UPDATE_WITH_FUNCTION_ERROR'
export const BULK_UPDATE_WITH_FUNCTION_REQUEST =
	'BULK_UPDATE_WITH_FUNCTION_REQUEST'
export const BULK_UPDATE_WITH_FUNCTION_SUCCESS =
	'BULK_UPDATE_WITH_FUNCTION_SUCCESS'
